<script setup>
import {mapErrors} from "@/utilities";
import {useForm} from "@inertiajs/vue3";
import ReactiveSlot from "@/Components/Buttons/Partials/ReactiveSlot.vue";
import {inject} from "vue";

const emits = defineEmits(['onSuccess']);
const route = inject('route')

const props = defineProps({
    variant: Object,
    quantity: Number,
})

const form = useForm({
    quantity: props.quantity,
    variant_id: props.variant.id
})

const submitForm = () => {
    form.transform(data => {
        return {
            ...data,
            quantity: props.quantity
        }
    }).post(route('public.shopping-cart-lines.store', {stay: true}), {
        preserveState: true,
        preserveScroll: true,
        onError: (errors) => (form.errors = mapErrors(errors)),
        onSuccess: () => (emits('onSuccess')),
    });
};

</script>

<template>
    <button
        type="button"
        class="flex-center relative size-10"
        @click="submitForm"
    >
        <ReactiveSlot
            :processing="form?.processing ?? false"
        >
            <slot />
        </ReactiveSlot>
    </button>
</template>
